import { Box, Text } from "grommet";
import React from "react";
import { Link, useLocation } from "react-router-dom";

import styled from "styled-components";

export const AppBarItem = styled.div`
    a {
        color: unset;
        text-decoration: none !important;
    }
`;

interface NavigationButtonProps {
    text: string | undefined;
    href: string;
    alt?: string;
    [key: string]: any;
}

export const NavigationButton = ({ text, href, alt, ...props }: NavigationButtonProps) => {
    let { pathname } = useLocation();

    const [isActive, setIsActive] = React.useState(false);

    React.useEffect(() => {
        let active = false;
        active = pathname.startsWith(href) || (!!alt && pathname.startsWith(alt));

        if (href == "/" && pathname != "/") {
            active = false;
        }

        setIsActive(active);
    }, [pathname, href]);

    return (
        <AppBarItem>
            <Link {...props} to={href}>
                <Box background={isActive ? "brand" : ""} className="app-bar-text" align="end" justify="end" hoverIndicator="background-front" pad={{ horizontal: "small", vertical: "xsmall" }} round="5px" onClick={() => {}}>
                    <Text color={isActive ? "white" : ""}>{text}</Text>
                </Box>
            </Link>
        </AppBarItem>
    );
};
